import { FINAL_PENDING_SCREEN, PROGRESS } from 'config/config';
import withProgressBar from 'hoc/withProgressBar';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  FinalPendingScreenButton,
  FinalPendingScreenContainer,
  FinalPendingScreenIcon,
  FinalPendingScreenStatus,
  FinalPendingScreenStatusText,
  FinalPendingScreenWrapper,
} from './FinalPendingScreen.styles';

const { status, statusText, icon, buttonText } = FINAL_PENDING_SCREEN;

class FinalPendingScreen extends PureComponent<IRedirect & Partial<IContext> & Partial<ITextContext>> {
  componentDidMount() {
    const { setPaymentStatusText } = this.props;
    if (setPaymentStatusText) {
      setPaymentStatusText('finalScreen.message5');
    }
  }

  handleClick = () => {
    this.redirectToUrl();
  };

  redirectToUrl = () => {
    const { redirect } = this.props;
    window.location.assign(redirect);
  };

  render() {
    return (
      <FinalPendingScreenContainer className="final-pending-screen__container">
        <FinalPendingScreenWrapper>
          <FinalPendingScreenStatus className="final-pending-screen__status">
            <FormattedMessage id={status} />
          </FinalPendingScreenStatus>
          <FinalPendingScreenIcon className="final-pending-screen__icon">
            <img src={icon} alt="icon" />
          </FinalPendingScreenIcon>
          <FinalPendingScreenStatusText className="final-pending-screen__statusText">
            <FormattedMessage id={statusText} />
          </FinalPendingScreenStatusText>
          <FinalPendingScreenButton onClick={this.handleClick} className="final-pending-screen__button">
            <button type="button" id="backToShop">
              <FormattedMessage id={buttonText} />
            </button>
          </FinalPendingScreenButton>
        </FinalPendingScreenWrapper>
      </FinalPendingScreenContainer>
    );
  }
}

export default withProgressBar(PROGRESS.PAYMENT_PENDING)(FinalPendingScreen);
